import { styled } from "@mui/material/styles";

import ResponsiveImage from "components/ResponsiveImage";

export const DefaultOccasion = styled("div")(({ theme }) => ({
  position: "absolute",
  height: 40,
  right: -10,
  top: -10,
  margin: 0,
  [theme.breakpoints.up("mobile")]: {
    height: 54,
  },
}));

export const DefaultBirthday = styled("div")(({ theme }) => ({
  position: "absolute",
  height: 40,
  right: 28,
  top: -12,
  margin: 0,
  [theme.breakpoints.up("mobile")]: {
    right: 43,
    height: 54,
    top: -13,
  },
}));

export const ImageOccasion = styled(ResponsiveImage)(({ theme }) => ({
  width: 40,
  height: 40,
  [theme.breakpoints.up("mobile")]: {
    width: 54,
    height: 54,
  },
}));

export const ImageBirthday = styled(ResponsiveImage)(({ theme }) => ({
  width: 28,
  height: 40,
  [theme.breakpoints.up("mobile")]: {
    width: 34,
    height: 54,
  },
}));
